import { Controller } from 'stimulus'

import Rails from '@rails/ujs'
import axios from 'axios'

export default class extends Controller {
  static targets = ['amountInput', 'articleInput', 'articleSku', 'articleTypeInput', 'autocompleteBox', 'descriptionInput']
  static values = { autocompleteIndex: String, autocompleteUrl: String }

  connect() {
    axios.defaults.headers.common['X-CSRF-Token'] = Rails.csrfToken()

    if (this.hasAmountInputTarget) {
      setTimeout(() => {
        // Wait and then trigger the change event and the amount input.
        // This way, we also calculate the total amount once 'quick' products are added (e.g. repair).
        this.amountInputTarget.dispatchEvent(new Event('input', { bubbles: true }))
      }, 200)
    }

    this.abortController = new AbortController()
    this.showProductsTimer = null
  }

  chooseProduct(event) {
    event.preventDefault()

    if (this.hasAmountInputTarget) {
      this.amountInputTarget.value = event.currentTarget.dataset.productPrice
      this.amountInputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }

    if (this.hasArticleTypeInputTarget) {
      this.articleTypeInputTarget.value = event.currentTarget.dataset.productType || 'Product::Item'
    }

    this.articleInputTarget.value = event.currentTarget.dataset.productId
    this.articleSkuTarget.value = event.currentTarget.dataset.productSku
    this.descriptionInputTarget.value = event.currentTarget.dataset.productDescription

    this.autocompleteBoxTarget.style.display = 'none'
  }

  chooseAndHideAutocompleteBox() {
    const results = this.autocompleteBoxTarget.querySelectorAll('.autocomplete__item')
    results[0].click()

    setTimeout(() => {
      // We have to wait one second to be sure we can close it.
      // Otherwise we're still waiting for the click and we want to close to soon.
      document.querySelectorAll('.autocomplete__box').forEach(box => {
        box.style.display = 'none'
      })
    }, 1000)
  }

  showProducts(event) {
    clearTimeout(this.showProductsTimer)

    if (event.key == 'Enter') {
      this.waitForElementToBeAdded('.autocomplete__box').then(targetDiv => {
        this.chooseAndHideAutocompleteBox()
      })
    }

    if (event.currentTarget.value == '' || event.key == 'Escape') {
      this.hideAutocompleteBox()
      return
    }

    if (event.key == 'Backspace' || event.key == 'Delete') {
      this.articleInputTarget.value = null
    }
    const value = event.currentTarget.value

    if (value.length < 2) {
      this.hideAutocompleteBox()
      return
    }

    const invoicesFormController = document.getElementById('invoices-form')['invoices-form']
    const invoiceableType = invoicesFormController.element.querySelector('.invoiceable-type').value
    const hasAmountsIncludingVatEnabled = invoicesFormController.amountsIncludingVatToggleTarget.checked

    this.showProductsTimer = setTimeout(() => {
      this.abortController.abort()
      this.abortController = new AbortController()

      axios.post(
        this.autocompleteUrlValue,
        {
          amountsIncludingVat: hasAmountsIncludingVatEnabled,
          index: this.autocompleteIndexValue,
          invoiceableType: invoiceableType,
          search: { query: value }
        },
        {
          signal: this.abortController.signal
        }
      ).then((response) => {
        if (response.data != '') {
          Turbo.renderStreamMessage(response.data)

          if (this.hasAutocompleteBoxTarget) {
            this.autocompleteBoxTarget.style.display = 'block'
          }
        } else {
          if (this.hasAutocompleteBoxTarget) {
            this.autocompleteBoxTarget.style.display = 'none'
          }
        }
      }).catch((error) => {
        if (error.message !== 'canceled') {
          console.error('Fout bij het verwerken van het verzoek', error)
        }
      })
    }, 300)
  }

  hideAutocompleteBox() {
    if (this.hasAutocompleteBoxTarget) {
      this.autocompleteBoxTarget.style.display = 'none'
    }
  }

  waitForElementToBeAdded(selector) {
    return new Promise(resolve => {
      const observer = new MutationObserver((mutationsList, observer) => {
        const targetNode = document.querySelector(selector)

        if (targetNode) {
          observer.disconnect()
          resolve(targetNode)
        }
      })

      observer.observe(document.body, { childList: true, subtree: true })
    })
  }
}
